import Pool from '../constants/UserPool';
import { setAuthorizationToken, removeAuthorizationToken } from './Auth';

const sessionExpiredResponse = {
  sessionExpired: true,
  response: {
    data: {
      message: "User session expired"
    }
  }
}

export const getAccessToken = async () =>
  await new Promise((resolve, reject) => {
    const user = Pool.getCurrentUser();
    if (user) {
      user.getSession((err, session) => {
        if (err) {
          reject(sessionExpiredResponse);
        } else {
          if (session.isValid()) {
            resolve(session.getIdToken().getJwtToken());
          } else {
            const refresh_token = session.getRefreshToken();

            user.refreshSession(refresh_token, (error, sesh) => {
              if (error) {
                reject(sessionExpiredResponse);
              } else {
                setAuthorizationToken(sesh.getIdToken().getJwtToken());
                resolve(sesh.getIdToken().getJwtToken());
              }
            });
          }

        }
      });
    } else {
      reject(sessionExpiredResponse);
    }
  });

export const setAccessToken = async () =>
  await new Promise((resolve, reject) => {
    const user = Pool.getCurrentUser();
    if (user) {
      user.getSession((err, session) => {
        if (err) {
          console.log({ err })
          reject();
        } else {
          setAuthorizationToken(session.getIdToken().getJwtToken());
          resolve(session.getIdToken().getJwtToken());
        }
      });
    } else {
      reject();
    }
  });

export const logout = () => {
  const user = Pool.getCurrentUser();
  if (user) {
    removeAuthorizationToken();
    user.signOut();
  }
};
